import {
  get_local,
  get_session,
  merge_normal_and_special_hours,
  set_local,
  set_session,
  timeConvert,
  weekdays_short
} from "../helpers";
import axios from "axios";

export default {
  template: '#vue-header-component',
  delimiters: ['${', '}'],
  props: ['pageType', 'template'],
  data: function () {
    return {
      active_nav: [],
      product_suggestions: [],
      collection_suggestions: [],
      auto_query: '',
      closed_notices: []
    }
  },
  computed: {
    country_notice_visible() {
      if (this.closed_notices.includes('country-notice')) {
        return false
      } else if (this.$store.state.location && this.$store.state.location.country !== this.$store.state.country) {
        return true
      }
      return false
    },
    url() {
      if (this.pageType === '404') {
        return this.$store.getters.locale_uri_prefix + '/404/'
      } else if (window.location.pathname.substring(window.location.pathname.length - 1) === '/') {
        return window.location.pathname;
      } else {
        return window.location.pathname + '/';
      }
    },
    open_status() {
      if (this.$store.getters.favorite_or_closest === null) {
        return null
      }
      const store_hours = merge_normal_and_special_hours(
          this.$store.getters.favorite_or_closest.opening_hours,
          this.$store.getters.favorite_or_closest.special_hours
      )
      if (!store_hours){
        return {open: false, next_time: null}
      }

      let current_date = new Date();
      let current_day = current_date.getDay();
      let current_time = current_date.getHours() * 60 + current_date.getMinutes() + current_date.getSeconds() / 60;
      let current_day_hours = store_hours[current_day];
      if (current_day_hours.start && current_day_hours.end && current_time >= this.time_to_int(current_day_hours.start) && current_time < this.time_to_int(current_day_hours.end)) {
        return {open: true, next_time: timeConvert(current_day_hours.end)}
      } else {
        if (current_day_hours.start && this.time_to_int(current_day_hours.start) > current_time) {
          return {open: false, next_time: timeConvert(current_day_hours.start)}
        }
        while (true) {
          current_day = (current_day >= 6 ? 0 : current_day + 1);
          if (current_day === current_date.getDay()) {
            return {open: false, next_time: null}
          }
          current_day_hours = store_hours[current_day];
          if (current_day_hours.start) {
            const current_dow = weekdays_short[this.$store.state.lang]()[current_day]
            return {open: false, next_time: `${timeConvert(current_day_hours.start)} ${current_dow}`}
          }
        }
      }
    }
  },
  methods: {
    image_thumbnail_url(e){
      let parts = e.split(/\./g)
      if (parts.length === 1){
        return e
      }
      parts[parts.length - 2] = parts[parts.length - 2] + '_40x40_crop_center.jpg'
      return parts.join('.')
    },
    time_to_int(e) {
      // converts 18:00:23 to a float representing MINUTES
      let parts = e.split(/:/g)
      if (parts.length === 3) {
        return (parseInt(parts[0]) * 60) + parseInt(parts[1]) + (parseInt(parts[2]) / 60)
      } else {
        return (parseInt(parts[0]) * 60) + parseInt(parts[1])
      }
    },
    dismissNotice(noticeId) {
      if (!this.closed_notices.includes(noticeId)) {
        this.closed_notices.push(noticeId);
        set_session('closed_notices', JSON.stringify(this.closed_notices));
      }
    },
    switchLanguage: function (e) {
      let pathname = window.location.pathname.toString()
      const target_lan = e.target.value
      if (target_lan === 'en') {
        if (pathname.toLowerCase().startsWith('/fr')) {
          pathname = pathname.substring(3)
        }
      } else {
        pathname = '/' + target_lan + pathname
      }
      window.location = `${window.location.protocol}//${window.location.host}${pathname}${window.location.search}`
    },
    openNav(id) {
      this.active_nav = id;
    },
    autoResults(event) {
      if (this.auto_query !== '') {
        axios.get(`${this.$store.getters.locale_uri_prefix}/search/suggest.json?q=${this.auto_query}`
            + '&resources[type]=product,collection'
            + '&resources[limit]=4'
            + '&resources[options][unavailable_products]=hide'
        )
        .then(response => {
          this.product_suggestions = this.auto_query !== '' ? response.data.resources.results.products || [] : [];
          this.collection_suggestions = this.auto_query !== '' ? response.data.resources.results.collections || [] : [];
        }, err => {
          console.warn('Error: Something went wrong with the request for suggestions.');
        });
      } else {
        this.product_suggestions = [];
        this.collection_suggestions = [];
      }
    },
    flyoutClick: function (event) {
      if (event) {
        event.preventDefault();
      }
      this.$store.commit({
        type: 'setFlyout',
        value: !this.$store.state.flyout
      });
      document.body.setAttribute('class', this.$store.state.flyout ? 'c-body--overlay c-body--flyout' : '');
    },
  },
  mounted: function () {
    if (this.template !== 'cart') {
      this.$store.dispatch("getCart").then(
          resp => {
          },
          err => {
          }
      )
    }
    this.$store.dispatch("getLocation").then(
        success => {
          this.$store.dispatch("getAllStores").then(() => {
          }, () => {
          })
        },
        () => {
        })
    setTimeout(() => {
      this.$store.dispatch("fireImpressions")
    }, 250)

    const s = get_session('closed_notices')
    this.closed_notices = s ? JSON.parse(s) : [];
  }
}